import React, { createContext, useState, useCallback, useContext, ReactNode } from 'react';

interface LogoutContextType {
    isLoggingOut: boolean;
    initiateLogout: () => void;
    completeLogout: () => void;
}

export const LogoutContext = createContext<LogoutContextType | undefined>(undefined);

interface LogoutProviderProps {
    children: ReactNode;
}

export const LogoutProvider: React.FC<LogoutProviderProps> = ({ children }) => {
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const initiateLogout = useCallback(() => {
        setIsLoggingOut(true);
    }, []);

    const completeLogout = useCallback(() => {
        setIsLoggingOut(false);
    }, []);

    return (
        <LogoutContext.Provider value={{ isLoggingOut, initiateLogout, completeLogout }}>
            {children}
        </LogoutContext.Provider>
    );
};

export const useLogoutContext = () => {
    const context = useContext(LogoutContext);
    if (!context) {
        throw new Error('useLogoutContext must be used within a LogoutProvider');
    }
    return context;
};
